<template>
  <div v-if="screenshotMode" class="screenshot-branding" :class="{ 'screenshot-branding--light': !isDark }">
    <img :src="isDark ? logoLightUrl : logoDarkUrl" alt="OroraTech" class="screenshot-branding-logo" />
    <span class="screenshot-branding-time">{{ timeRangeLabel }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import logoLightUrl from '@/assets/img/OT_Logo_RGB_CONNECTED_light.svg?url';
import logoDarkUrl from '@/assets/img/OT_Logo_RGB_CONNECRTED_dark.svg?url';
import { useFilterStore } from '@/composables/useFilterStore';
import { useDateTimeSettings } from '@/composables/useDateTimeSettings';
import { useScreenshotMode } from '@/composables/useScreenshotMode';
import { useColorScheme } from '@/composables/useColorScheme';

const { screenshotMode } = useScreenshotMode();
const { timeRange } = useFilterStore();
const { formatDateTime } = useDateTimeSettings();
const { realColorScheme } = useColorScheme();

const isDark = computed(() => realColorScheme.value === 'dark');

const timeRangeLabel = computed(() => {
  const start = formatDateTime(timeRange.value[0]);
  const end = formatDateTime(timeRange.value[1]);
  return `${start} - ${end}`;
});
</script>

<style scoped lang="scss">
.screenshot-branding {
  position: absolute;
  bottom: var(--mk-footer-height, 24px);
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.45rem 0.85rem;
  background: rgba(12, 35, 43, 0.6);
  border-radius: 0 6px 0 0;
  pointer-events: none;

  &--light {
    background: rgba(255, 255, 255, 0.6);
  }
}

.screenshot-branding-logo {
  height: 22px;
  width: auto;
  flex-shrink: 0;
}

.screenshot-branding-time {
  color: rgba(255, 255, 255, 0.88);
  font-size: 0.78rem;
  font-weight: 500;
  white-space: nowrap;
  letter-spacing: 0.01em;

  .screenshot-branding--light & {
    color: rgba(12, 35, 43, 0.85);
  }
}
</style>
